import { render, staticRenderFns } from "./VideoAvatarPreview.vue?vue&type=template&id=3d5394e4&scoped=true"
import script from "./VideoAvatarPreview.vue?vue&type=script&lang=ts"
export * from "./VideoAvatarPreview.vue?vue&type=script&lang=ts"
import style0 from "./VideoAvatarPreview.vue?vue&type=style&index=0&id=3d5394e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5394e4",
  null
  
)

export default component.exports